import PropTypes from 'prop-types';
import { Switch, Case } from '../../switchComponent';
import DocumentExpiredNotification from './documentExpiredNotification';
import ActivityNotification from './activityNotification';
import { NOTIFICATION_MODEL_KEYS } from '../../../../constants/globalNotifications';
import { prepareNotificationItem } from '../../../../utility/globalNotifications';

const ACTIVITY_MODELS = [
  NOTIFICATION_MODEL_KEYS.ACTION_PLAN,
  NOTIFICATION_MODEL_KEYS.NOTE,
  NOTIFICATION_MODEL_KEYS.ONE_ON_ONE,
];

const NotificationItem = ({ translations, data, onMarkAsRead }) => {
  const { model } = data;
  const { DOCUMENT } = NOTIFICATION_MODEL_KEYS;
  const notificationItem = prepareNotificationItem(
    {
      models: translations.models,
      actions: translations.actions,
    },
    data
  );
  const title = [notificationItem.model, notificationItem.action]
    .filter(Boolean)
    .join(' - ');
  const itemTranslations = {
    title,
    markAsRead: translations.markAsRead,
  };

  return (
    <Switch condition={model}>
      <Case when={DOCUMENT}>
        <DocumentExpiredNotification
          translations={itemTranslations}
          data={data}
          onMarkAsRead={onMarkAsRead}
        />
      </Case>
      <Case when={ACTIVITY_MODELS}>
        <ActivityNotification
          translations={itemTranslations}
          data={data}
          onMarkAsRead={onMarkAsRead}
        />
      </Case>
    </Switch>
  );
};

NotificationItem.propTypes = {
  translations: PropTypes.object.isRequired,
  data: PropTypes.shape({
    model: PropTypes.string.isRequired,
    action: PropTypes.string,
  }).isRequired,
  onMarkAsRead: PropTypes.func.isRequired,
};

export default NotificationItem;
